import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'

import Logo from 'components/atoms/Logo'
import LoginForm from 'components/organisms/LoginForm'
import FormResult from 'components/organisms/FormResult'
import FormHeading from 'components/molecules/FormHeading'
import ProgressLoader from 'components/atoms/ProgressLoader'
import CreateAccountForm from 'components/organisms/CreateAccountForm'

const styles = theme => ({
  root: {
    maxWidth: 350,
    display: 'flex',
    margin: '0 auto',
    minHeight: '100vh',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      maxWidth: 450,
    },
  },
  content: {
    textAlign: 'center',
    padding: `0 ${theme.spacing(2)}px`,
  },
  logo: {
    marginBottom: theme.spacing(6),
  },
  description: {
    margin: `${theme.spacing(1)}px 0`,
    color: theme.palette.disabled.main,
  },
  action: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    color: theme.palette.disabled.main,
  },
  link: {
    marginLeft: 4,
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
})

const AdminInviteVerify = ({
  state,
  classes,
  hasError,
  changeState,
  errorMessage,
  hasLoginError,
  onLoginSubmit,
  onSignupSubmit,
  hasSignupError,
  handleSignupClick,
}) => {
  function getContent() {
    if (state === 'signin') {
      return (
        <Fragment>
          <Typography variant="h1">First, lets sign you in.</Typography>
          <Typography className={classes.description}>
            You can use your goodnature account for this
          </Typography>
          <LoginForm onLogin={onLoginSubmit} apiCallError={hasLoginError} />
          <Typography className={classes.action} onClick={handleSignupClick}>
            Don't have an account?{' '}
            <span
              className={classes.link}
              onClick={() => changeState('signup')}>
              {' '}
              Sign up
            </span>
          </Typography>
          <Typography>
            <Link href="/reset">Forgot password?</Link>
          </Typography>
        </Fragment>
      )
    } else if (state === 'signup') {
      return (
        <Fragment>
          <CreateAccountForm
            onCreateSubmit={onSignupSubmit}
            apiCallError={hasSignupError}
          />
          <Typography className={classes.action} onClick={handleSignupClick}>
            Have an account?{' '}
            <span
              className={classes.link}
              onClick={() => changeState('signin')}>
              {' '}
              Login
            </span>
          </Typography>
          <Typography>
            <Link href="/reset">Forgot password?</Link>
          </Typography>
        </Fragment>
      )
    }
    return !hasError ? (
      <div className={classes.content}>
        <FormHeading heading="Verifying your invitation..." />
        <ProgressLoader color="primary" />
      </div>
    ) : (
      <div className={classes.content}>
        <FormResult
          hideButton
          heading="Something went wrong"
          subHeading={errorMessage}
        />
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <Logo className={classes.logo} />
      {getContent()}
    </div>
  )
}

AdminInviteVerify.propTypes = {
  state: PropTypes.string,
  hasError: PropTypes.bool,
  classes: PropTypes.object,
  changeState: PropTypes.func,
  hasLoginError: PropTypes.bool,
  onLoginSubmit: PropTypes.func,
  requiresSignup: PropTypes.bool,
  errorMessage: PropTypes.string,
  onSignupSubmit: PropTypes.func,
  hasSignupError: PropTypes.bool,
  handleSignupClick: PropTypes.func,
}

export default withStyles(styles)(AdminInviteVerify)



// WEBPACK FOOTER //
// ./src/containers/invitations/AdminInviteVerify/AdminInviteVerify.js